import React from 'react'
import { Heading } from '@myxplor/ui'

import RemoteTypeAheadSelect from '../../../../ui/forms/type-ahead'

const ManconPersonnelFormFields = ({ onChange, ccs_provider_registration_id }) => {

  return (
    <div>
      <Heading small compact>
        Change Management & Control Personnel
      </Heading>

      <fieldset>
        <RemoteTypeAheadSelect
          name="gov_id"
          label="Management & Control Personnel"
          required
          onChange={onChange}
          apiEndPoint={`/api/provider-registrations/${ccs_provider_registration_id}/personnel`}
          optionsFilter={options =>
            options.map(({ gov_record }) => ({
              value: gov_record.personID,
              label: `${gov_record.firstName} ${gov_record.lastName} - ${gov_record.personID}`,
            }))
          }
        />
      </fieldset>
    </div>
  )
}

export default ManconPersonnelFormFields



// WEBPACK FOOTER //
// ./src/providers-registrations/b2b-device-list/actions/change-action/form.jsx